// Google Analytics Tracking ID
//https://github.com/BijanSaud1/MyPortfolio#-google-analytics
export const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || "";
